
import React, { useState } from 'react';
import { AutomationRuleConditionTypes, ConditionModel } from '../../models/automations.model';
import { appNote, buttonLabels } from '../shared/constants';
import { validateForm } from '../shared/form-validation';
import ButtonComponent from "../shared/button/button.component";
import MessageComposer from '../conversations/message-composer';
import { CancelIcon } from "../../icon";
import { ConversationType } from "../../models/conversations";
import { ChannelAccountModel, ChannelType } from "../../models/channels/channels.model";
import AddConditionCardComponent from "./add-condition-card.component";
import { toNumber } from "lodash";
import { ChannelConversationService } from "../../services/channels/ChannelConversationService";
import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, TextField, Tooltip, styled } from '@mui/material';
import * as selector from '../../selectors/selectors';
import { useSelector } from 'react-redux';
import { ChannelUserService } from '../../services/ChannelUserService';
import { MediaType, MessageType } from '../../models/media.models';


const StyledFormControlLabel = styled(FormControlLabel)({
    fontSize: '0.5rem', // adjust label font size as needed
});

const StyledRadio = styled(Radio)({
    '& .MuiSvgIcon-root': {
        width: '0.75em', // adjust radio button size as needed
        height: '0.75em',
        color: "#1450FF",
    },
    '&:hover': {
        backgroundColor: 'transparent',
        color: '#1450FF', // set the hover color to blue
    },
});

let facebookConditions = [
    { Name: 'Location', Value: AutomationRuleConditionTypes.LOCATION },
    { Name: 'Gender', Value: AutomationRuleConditionTypes.GENDER },
    { Name: 'Message Inactivity', Value: AutomationRuleConditionTypes.MESSAGE_ACTIVITY },
    { Name: 'Keywords', Value: AutomationRuleConditionTypes.KEYWORDS },
    { Name: 'Business Information', Value: AutomationRuleConditionTypes.BUSINESS_INFORMATION },
    { Name: 'Status', Value: AutomationRuleConditionTypes.STATUS },
];
let LiveChatConditions = [
    { Name: 'Message Inactivity', Value: AutomationRuleConditionTypes.MESSAGE_ACTIVITY },
    { Name: 'Keywords', Value: AutomationRuleConditionTypes.KEYWORDS },
];

interface IProps {
    OnClose: (confirm: boolean) => void;
    Show: boolean;
    Rule?: any;
    ButtonLabel?: string;
    HandleSubmitSuccess?: (e: any) => void;
    Channel?: number;
    Page?: any;
}

const AddRuleComponent: React.FC<IProps> = (props: IProps) => {
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)

    const user = ChannelUserService.getCurrentUserFromLocalStorage();
    const [errors, setErrors] = useState<{
        Name: string;
        Message: string;
        SelectedConditions: string;
        SelectedChannel: string;
        SelectedPage: string;
    }>({
        Name: "",
        Message: "",
        SelectedConditions: "",
        SelectedChannel: "",
        SelectedPage: "",
    });

    const [rule, setRule] = useState<{
        ID: string;
        Name: string;
        IsOneTime: boolean;
        Message: string;
    }>(props.Rule ?
        {
            ID: props.Rule.Id || "", Name: props.Rule?.AutomationName || "", IsOneTime: props.Rule?.TriggerOnce, Message: props.Rule?.Actions?.filter(x => x.ActionValue.Type === "text")[0]?.ActionValue?.Value || ""
        }
        :
        {
            ID: "",
            Name: "",
            IsOneTime: true,
            Message: "",
        }
    );

    const [media, setMedia] = useState<any>(props.Rule ?
        !!props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")?.length ? { ContentType: props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Type || "", ID: "", Name: "", Url: props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Value || "" } : "" :
        {
            ContentType: "",
            ID: "",
            Name: "",
            Url: ""
        }
    );
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [messageLength, setMessageLength] = useState<number>(0);
    const [selectedChannel, setSelectedChannel] = useState<number>(props.Channel);
    const [selectedPage, setSelectedPage] = useState<any>(props.Page ? Channels.find(x => x.ID === props.Page) : null);
    const [selectedConditions, setSelectedConditions] = useState<ConditionModel[]>(props.Rule?.Conditions?.map(
        x => {
            return {
                id: x.ConditionName,
                condition: { Name: (selectedChannel === ConversationType.FACEBOOK ? facebookConditions : LiveChatConditions).find(y => y.Value === x.ConditionName).Name, Value: x.ConditionName },
                value: x.ConditionValues,
                conditionError: "",
                valueError: "",
            } as ConditionModel
        }
    ));
    const [conditionStatus, setConditionStatus] = useState<string>("2");
    const [conditionErrors, setConditionErrors] = useState<boolean>(false);

    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
        setRule({ ...rule, [name]: value })
    };

    const handleRecurringTrigger = (e: any) => {
        setRule({ ...rule, IsOneTime: e.target?.checked })
    };

    const getMediaType = (type: string) => {
        if (type != null) {
            const mediatype = type.split('/')[0];
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                case MediaType.IMAGE_SVG:
                    return MessageType.IMAGE
                case MediaType.VIDEO:
                    return MessageType.VIDEO
                case MediaType.AUDIO:
                    return MessageType.AUDIO
                default:
                    return MessageType.FILE
            }
        }
    }

    async function fileToBase64(file) {
        if (media?.Url?.includes("s3")) {
            let extension = props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Value?.substring(props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Value.lastIndexOf(".") + 1) === "svg" ? "image/svg+xml" : props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Type;
            let fileblob = new File([await ((await fetch(media?.Url)).blob())], props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Payload?.file_name, { type: extension });
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    if (typeof reader.result === 'string') {
                        const base64String = reader.result.split(',')[1]; // Extract base64 data from result
                        resolve(base64String);
                    } else {
                        reject(new Error('Failed to read file as Base64.'));
                    }
                };

                reader.onerror = error => reject(error);

                reader.readAsDataURL(fileblob);
            });
        }
        else {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    if (typeof reader.result === 'string') {
                        const base64String = reader.result.split(',')[1]; // Extract base64 data from result
                        resolve(base64String);
                    } else {
                        reject(new Error('Failed to read file as Base64.'));
                    }
                };

                reader.onerror = error => reject(error);

                reader.readAsDataURL(file);
            });
        }
    }

    const formSubmit = async (e: any) => {
        e.preventDefault();
        if (!selectedChannel) {
            setErrors({ ...errors, SelectedChannel: "Channel cannot be blank" })
        }
        else {
            let valueError: boolean = false
            let validate = !!media ? { Name: rule.Name } : { Name: rule.Name, Message: rule.Message }
            validateForm(validate, (Errors) => {
                setErrors({ ...errors, ...Errors })
                if (selectedPage?.length < 1) {
                    setErrors({ ...errors, ...Errors, SelectedPage: "Page cannot be blank" })
                }
                if (selectedConditions.length < 1) {
                    setErrors({ ...errors, ...Errors, SelectedConditions: "Atleast one condition is required" })
                }
                if (selectedConditions.length < 1 && selectedPage.length < 1) {
                    setErrors({ ...errors, ...Errors, SelectedConditions: "Atleast one condition is required", SelectedPage: "Page cannot be blank" })
                }
            })
            if ((selectedConditions.find(x => x.condition === null) || !!selectedConditions.find(x => x.value.toString() === "") || !!selectedConditions.find(x => x.valueError))) {
                setConditionErrors(true)
                valueError = true
            }
            if (!selectedChannel || !!selectedChannel && !selectedPage || !selectedConditions.length || valueError || !rule.Name || (!!media ? false : !rule.Message)) {
                return
            }
            if (!rule.ID) {
                setIsLoading(true)
                ChannelConversationService.addChannelAutomatedReply(user.OrganizationID, selectedChannel, {
                    channel_accounts: [selectedPage.ID],
                    automation_name: rule.Name,
                    conditions: selectedConditions.map(x => {
                        return {
                            condition_name: x.condition.Value,
                            condition_values: x.value,

                        }
                    }),
                    condition_status: toNumber(conditionStatus),
                    actions:
                        !!media && rule.Message ? [{
                            action_name: "reply",
                            action_value: {
                                type: "text",
                                value: rule.Message,
                            }
                        },
                        {
                            action_name: "reply",
                            action_value: {
                                type: getMediaType(media?.type),

                                value: await fileToBase64(media),
                                payload: {
                                    file_name: media.name
                                }
                            }
                        }]
                            :
                            !media && rule.Message ?
                                [{
                                    action_name: "reply",
                                    action_value: {
                                        type: "text",
                                        value: rule.Message,
                                    }
                                }]
                                :

                                [{
                                    action_name: "reply",
                                    action_value: {
                                        type: getMediaType(media?.type),

                                        value: await fileToBase64(media),
                                        payload: {
                                            file_name: media.name
                                        }
                                    }
                                }]
                    ,
                    trigger_once: rule.IsOneTime
                }).then(res => {
                    setIsLoading(false)
                    props.HandleSubmitSuccess(e)
                    props.OnClose(true);
                }).catch(err => { })
            }
            else {
                setIsLoading(true)
                ChannelConversationService.UpdateAutomatedReplyById(user.OrganizationID, rule.ID, {
                    channel_accounts: [selectedPage.ID],
                    automation_name: rule.Name,
                    conditions: selectedConditions.map(x => {
                        return {
                            condition_name: x.condition.Value,
                            condition_values: x.value
                        }
                    }),
                    condition_status: toNumber(conditionStatus),
                    actions: !!media && rule.Message ? [{
                        action_name: "reply",
                        action_value: {
                            type: "text",
                            value: rule.Message,
                        }
                    },
                    {
                        action_name: "reply",
                        action_value: {
                            type: getMediaType(!!media?.type ? media?.type : props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Type),

                            value: await fileToBase64(media),
                            payload: {
                                file_name: !!media.name ? media.name : props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Payload?.file_name
                            }
                        }
                    }]
                        :
                        !media && rule.Message ?
                            [{
                                action_name: "reply",
                                action_value: {
                                    type: "text",
                                    value: rule.Message,
                                }
                            }]
                            :

                            [{
                                action_name: "reply",
                                action_value: {
                                    type: getMediaType(!!media?.type ? media?.type : props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Type),

                                    value: await fileToBase64(media),
                                    payload: {
                                        file_name: !!media.name ? media.name : props.Rule?.Actions?.filter(x => x.ActionValue.Type !== "text")[0]?.ActionValue?.Payload?.file_name
                                    }
                                }
                            }]
                    ,
                    trigger_once: rule.IsOneTime
                }).then(res => {
                    setIsLoading(false)
                    props.HandleSubmitSuccess(e)
                    props.OnClose(true);
                }).catch(err => { })
            }
        }
    }


    const handleMessageChanges = (data: { body: string, media: any, bodyLength: number }) => {
        if ((!data.body && !data.media) || (data.body.length <= 0 && data.media.length <= 0)) {
            setRule({ ...rule, Message: data.body })
            setMedia(data.media)
            setMessageLength(data.bodyLength)
            setErrors({ ...errors, Message: "Message cannot be blank" })
        } else {
            setRule({ ...rule, Message: data.body })
            setMedia(data.media)
            setMessageLength(data.bodyLength)
            setErrors({ ...errors, Message: "" })
        }
    }

    const handleChannel = (value: number) => {
        setRule({ ...rule, Message: "", Name: "", IsOneTime: true })
        setSelectedChannel(value)
        setErrors({
            Name: "",
            Message: "",
            SelectedConditions: "",
            SelectedChannel: "",
            SelectedPage: "",
        })
        setSelectedPage(null)
        setConditionStatus("2")
        setConditionErrors(false)
    }

    const handlePage = (event, value) => {
        // let selectedPages = valueslist.filter((x, i) => typeof x !== "string");
        // selectedPages.filter((x, index) => selectedPages.findIndex(y => y.ID === x.ID) === index)
        setSelectedPage(value)
        setErrors({ ...errors, SelectedPage: "" })
    }


    const handleSelectedConditions = (selectedConditions: ConditionModel[]) => {
        setSelectedConditions(selectedConditions)
        setConditionErrors(false)
        setErrors({ ...errors, SelectedConditions: "" })
    }

    const handleConditionStatus = (event) => {
        setConditionStatus(event.target?.value)
    }

    return <div className="w-fill">
        <Dialog
            maxWidth="lg"
            fullWidth={true}
            disableEscapeKeyDown
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={props.Show}
            onClose={() => props.OnClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: "w-98 br-2 dialogue-shadow p-2" }}
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header ">
                <div className='d-flex align-center'>
                    <span className={"h2-medium color-send-msg-title"}>{!!rule.ID ? 'Edit automation rule for ' : 'Create automation rule for '}</span>
                    <span className='h2-semibold color-primary-light ml-1'>{selectedPage?.Name}</span>
                    <span className='h2-medium color-send-msg-title ml-1'>{selectedChannel === ChannelType.LIVE_CHAT ? "live chat" : selectedChannel === ChannelType.FACEBOOK ? "facebook" : "whatsapp"}</span>
                    <Tooltip title='Close' placement='bottom-start'>
                        <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.OnClose(false)} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <div className={"bb-primary-background-pink-4 w-p-94 mx-auto"}></div>
            <DialogContent className="o-x-hidden pb-0">
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        {/* <SelectChannelComponent Channel={handleChannel} ChannelType={selectedChannel} ClassName={"mb-1"} IsSelectChannelDisable={true} />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                {errors.SelectedChannel}
                            </FormHelperText>
                                <>
                                    <Autocomplete
                                        disabled={true}
                                        className={`mt-2 ${errors.SelectedPage ? "" : "mb-2"}`}
                                        value={selectedPage}
                                        onChange={handlePage}
                                        options={(Channels.filter(x => x.ChannelType === selectedChannel))}
                                        getOptionLabel={(page) => page?.Name}
                                        classes={{
                                            option: "custom-option",
                                            input: `color-text-field-font h4-regular`
                                        }}
                                        renderOption={(defaultProps, page) => (
                                            <li {...defaultProps} className={"h4-regular font-bold d-flex justify-between w-p-100"}>
                                                <div className='px-2 py-1'>
                                                    {page.Name}
                                                </div>
                                            </li>
                                        )}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={`${selectedChannel === ConversationType.LIVE_CHAT ? "Select LiveChat" : selectedChannel === ConversationType.GOOGLE_BUSINESS_MESSAGES ? "Select Agent" : "Select Page"}`}
                                                required
                                                variant='outlined'
                                                size='small'
                                                InputLabelProps={{
                                                    shrink: true,
                                                }} />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.SelectedPage}
                                    </FormHelperText>
                                </>
                             */}
                        <div className='h5-medium color-primary-accent'>
                            Enter the Automation Name*
                        </div>
                        <TextField
                            className={""}
                            name="Name"
                            placeholder={`Enter the Automation Name`}
                            label={``}
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                            value={rule.Name}
                            onChange={(e) => handleChange(e.target.name, e.target.value)
                            }
                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                            autoComplete='no'
                        />
                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                            {errors.Name}
                        </FormHelperText>
                        {!!selectedChannel &&
                            <>
                                {(selectedChannel === ConversationType.FACEBOOK || selectedChannel === ConversationType.INSTAGRAM) &&
                                    <div>
                                        <span className={"h4-bold color-display-title "}>Conditions</span>

                                        <RadioGroup
                                            name="time-options"
                                            value={conditionStatus}
                                            onChange={handleConditionStatus}
                                            className="d-flex flex-direction-row pl-1"
                                            style={{ fontSize: '92px' }}
                                        >
                                            <StyledFormControlLabel
                                                value={"2"}
                                                defaultChecked={true}
                                                control={<StyledRadio />}
                                                label="Atleast one of the conditions"
                                            />
                                            <StyledFormControlLabel
                                                value={"1"}
                                                control={<StyledRadio />}
                                                label="All the following conditions"
                                            />
                                        </RadioGroup>
                                    </div>
                                }
                                <AddConditionCardComponent conditions={selectedChannel === ConversationType.FACEBOOK ? facebookConditions : LiveChatConditions} channel={selectedChannel} handleSelectedOptions={handleSelectedConditions} selectedConditions={selectedConditions} conditionErrors={conditionErrors} />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.SelectedConditions}
                                </FormHelperText>

                                {selectedConditions?.find(x => x.condition?.Name !== "Message Inactivity") &&
                                    <>
                                        <div className={"h5-medium color-primary-accent d-block pt-1"}>When this Happens</div>
                                        <TextField
                                            className="mb-1 color-primary-accent"
                                            disabled={true}
                                            name="condition"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={"Received Messages"}
                                            InputProps={{ classes: { input: 'h4-semibold color-primary-accent' } }}
                                            // .MuiInputBase-input.Mui-disabled
                                            autoComplete='no'
                                        />
                                    </>
                                }

                                <div className={"color-primary-light h4-semibold"}>Actions</div>
                                <span className={"footnote-medium color-conv-date d-block"}>Choose actions to take when your conditions are met</span>
                                <br></br>
                                <TextField
                                    // disabled={true}
                                    name="Action"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    disabled
                                    value={"Send Message"}
                                    InputProps={{ classes: { input: 'h4-semibold color-primary-accent' } }}
                                    autoComplete='no'
                                />

                            </>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <MessageComposer
                            HandleClose={() => props.OnClose(false)}
                            Message={rule.Message}
                            Media={media}
                            HandleChange={handleMessageChanges}
                            IsNewMessage={true}
                            IsAddRule={true}
                            PhoneNumbers={[]}
                            Limit={1}
                        />
                    </Grid>

                    {!!errors.Message && <Grid md={12} className='ml-auto mr-1 pb-1'>
                        <FormHelperText className="h6-regular color-primary-danger  t-align-right">
                            {errors.Message}
                        </FormHelperText>
                    </Grid>
                    }

                    <Grid item xs={6} md={6} className={`${IsTeamsApp && "mt-2"} py-0`}>
                        <FormControlLabel classes={{ label: 'h5-regular w-space color-primary-accent' }} control={
                            <Checkbox
                                checked={rule.IsOneTime}
                                value={rule.IsOneTime}
                                onChange={handleRecurringTrigger}
                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} name="keepSignedIn" />}
                            label={appNote.TRIGGER_RULE_ONLY_ONCE} />
                    </Grid>


                    <Grid item xs={6} md={6} className='p-0'>
                        <div className="d-flex float-right pb-2">
                            <ButtonComponent Type={"submit"} OnClick={formSubmit} ButtonLabel={props.ButtonLabel || buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={"primary-btn-small"} Loading={isLoading} />
                            <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={""} Variant={"secondary-btn-small"} /></div>
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions className='py-0'>
            </DialogActions>
        </Dialog >
    </div >
}


export default AddRuleComponent;